import React from "react";

export const InputComponent = ({
  value,
  changeValue,
  name,
  subName,
  type = "text",
  id,
  required = false,
  min = 0,
  max = 10000,
}) => {
  return (
    <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
      <label htmlFor={id} className="font-medium">
        {name}
      </label>
      {subName ? (
        <label htmlFor={id} className="text-gray-400">
          ({subName})
        </label>
      ) : (
        false
      )}
      {required ? <label className="text-[red] pl-1">*</label> : <></>}
      <br />
      <input
        className="outline-none border-b border-gray-500 w-4/5 sm:w-3/5 mt-4 transition-all duration-300 focus:border-[#1976D2]"
        required={required}
        type={type}
        id={id}
        minLength={min}
        maxLength={max}
        value={value}
        onChange={(event) => {
          if (type === "tel" || type === "number") {
            if (!isNaN(event.target.value) && event.target.value !== " ") {
              changeValue(event.target.value);
            }
          } else {
            changeValue(event.target.value);
          }
        }}
        placeholder={name}
      />
    </div>
  );
};
